import { render } from "./customerheader.vue?vue&type=template&id=54038ecc"
import script from "./customerheader.vue?vue&type=script&lang=js"
export * from "./customerheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__